$(document).on("click", ".open-image-modal", function(e) {
    e.preventDefault();

    const $elem = $(this);
    const html = $elem.data("info");

    const $modal = $(".image-modal");
    $modal.find(".modal-body img").attr('src', $elem.data("img"));

    $modal.find(".modal-body div.info").show();
    if (html && html.length) {
        $modal.find(".modal-body div.info").html(html);
    } else {
        $modal.find(".modal-body div.info").hide();
    }

    $modal.modal().show();
});
